'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _paginationShape = require('./paginationShape');

var _paginationShape2 = _interopRequireDefault(_paginationShape);

var _bibShape = require('./bibShape');

var _bibShape2 = _interopRequireDefault(_bibShape);

var _searchQueryShape = require('./searchQueryShape');

var _searchQueryShape2 = _interopRequireDefault(_searchQueryShape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addTitleResultShape = _reactImmutableProptypes2.default.contains({
  searchQuery: _searchQueryShape2.default.isRequired,
  zeroResults: _react.PropTypes.bool.isRequired,
  pagination: _paginationShape2.default.isRequired,
  items: _reactImmutableProptypes2.default.listOf(_bibShape2.default).isRequired,
  isFetching: _react.PropTypes.bool
});

exports.default = addTitleResultShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/bc-prop-types/lib/components/addTitleResultShape.js
// module id = 1369
// module chunks = 1